(() => {
  const track = name => {
    try {
      if (window.Shopify?.customerPrivacy?.analyticsProcessingAllowed() !== true) return;
      const published = window.Shopify?.analytics?.publish('kingston_tallow:' + name, {version: 1});
      published?.catch?.(() => {});
    } catch (_) {}
  };
  function init(root = document) {
    const legacyLavender = {'42028132532297':'67844331176009','42028132696137':'67844331208777'};
    const previousVariant = new URLSearchParams(location.search).get('variant');
    if (location.pathname.endsWith('/products/tallow-balm') && legacyLavender[previousVariant]) {
      location.replace((window.Shopify?.routes?.root || '/') + 'products/lavender-tallow-balm?variant=' + legacyLavender[previousVariant]); return;
    }
    root.querySelectorAll('[data-kt-chooser]').forEach(select => {
      if (select.dataset.ready) return; select.dataset.ready = 'true';
      select.addEventListener('change', () => {
        const option = select.selectedOptions[0], stage = select.closest('[data-kt-stage]'), image = stage.querySelector('[data-kt-image]');
        image.src = option.dataset.image; image.srcset = ''; image.alt = option.dataset.title;
        stage.querySelector('[data-kt-title]').textContent = option.dataset.title;
        stage.querySelector('[data-kt-price]').textContent = option.dataset.price;
        stage.querySelector('[data-kt-link]').href = option.value;
      });
    });
    const externalLinks = scope => scope.querySelectorAll('a[href]').forEach(link => {
      const url = new URL(link.href, location.href);
      if (/^https?:$/.test(url.protocol) && url.origin !== location.origin) {
        link.target = '_blank'; link.rel = 'noopener noreferrer';
      }
    });
    externalLinks(root);
    if (!document.documentElement.dataset.ktLinks) {
      document.documentElement.dataset.ktLinks = 'true';
      new MutationObserver(records => records.forEach(record => record.addedNodes.forEach(node => {
        if (node.nodeType === 1) { if (node.matches('a[href]')) externalLinks(node.parentElement); else externalLinks(node); }
      }))).observe(document.body, {childList:true,subtree:true});
    }
    const dataNode = document.getElementById('kt-balm-data');
    const products = dataNode ? JSON.parse(dataNode.textContent) : [];
    const lip = products.find(p => p.handle === 'tallow-lip-balm');
    const jars = products.filter(p => p !== lip);
    const sized = (v, size) => new RegExp('(^|\\D)' + size + '\\s*oz', 'i').test(v.title);
    root.querySelectorAll('[data-kt-finder]').forEach(form => {
      if (form.dataset.ready) return; form.dataset.ready = 'true'; form.noValidate = true;
      let step = 0, started = false;
      const panel = form.parentElement, questions = [...form.querySelectorAll('fieldset')], result = panel.querySelector('[data-kt-result]');
      const answer = name => form.querySelector(`input[name="kt-${name}"]:checked`)?.value;
      const show = () => {
        const isLip = answer('purpose') === 'lip', total = isLip ? 2 : 3;
        questions.forEach((q, i) => { q.hidden = i !== step; q.querySelectorAll('input').forEach(input => input.required = false); });
        form.querySelectorAll('[data-kt-jar-answer]').forEach(e => { e.hidden = isLip; e.querySelector('input').disabled = isLip; });
        form.querySelectorAll('[data-kt-lip-answer]').forEach(e => { e.hidden = !isLip; e.querySelector('input').disabled = !isLip; });
        form.querySelector('[data-kt-step]').textContent = step + 1;
        form.querySelector('[data-kt-total]').textContent = total;
        form.querySelector('[data-kt-back]').hidden = step === 0;
        form.querySelector('[data-kt-next]').textContent = step === total - 1 ? 'Meet my match' : 'Next question';
        form.querySelector('[data-kt-quiz-error]').textContent = '';
      };
      form.querySelector('[data-kt-back]').addEventListener('click', () => { step--; show(); questions[step].querySelector('input:not(:disabled)').focus(); });
      form.addEventListener('submit', event => {
        event.preventDefault();
        if (!questions[step].querySelector('input:checked:not(:disabled)')) { form.querySelector('[data-kt-quiz-error]').textContent = 'Pick the answer that sounds most like you.'; return; }
        if (!started) { track('finder_started'); started = true; }
        if (step < (answer('purpose') === 'lip' ? 1 : 2)) { step++; show(); questions[step].querySelector('input:not(:disabled)').focus(); return; }
        const tone = answer('tone'), size = answer('size'), gift = answer('purpose') === 'gift';
        let product, variant, note = '';
        if (answer('purpose') === 'lip') {
          product = lip; variant = lip.variants.find(v => v.available && (tone === 'any' || (tone === 'honey' ? !/vanilla/i.test(v.title) : /vanilla/i.test(v.title))));
        } else {
          product = tone === 'berry' ? jars.find(p => p.handle.includes('haskap')) : tone === 'none' ? jars.find(p => p.handle === 'tallow-balm') : tone === 'lavender' ? jars.find(p => p.handle === 'lavender-tallow-balm') : jars.find(p => p.handle.includes('vanilla'));
          const matches = v => sized(v, size);
          variant = product.variants.find(v => matches(v) && v.available);
          if (!variant && tone === 'any') {
            product = jars.find(p => p.variants.some(v => v.available && sized(v, size))) || product;
            variant = product.variants.find(v => v.available && sized(v, size));
          }
          if (!variant) { variant = product.variants.find(matches) || product.variants[0]; note = 'Your preferred formula or size is currently sold out. Check the product page for other options; we haven’t swapped your preference.'; }
        }
        variant ||= product.variants[0];
        const set = (key, text) => result.querySelector(`[data-kt-result-${key}]`).textContent = text;
        const image = result.querySelector('img'); image.src = product.image; image.alt = product.title;
        set('title', product.title + ' · ' + variant.title);
        set('reason', gift ? 'A thoughtful little jar. Add a lip balm through the double act below for the pairing offer.' : tone === 'none' ? 'No added botanical infusion. A short ingredient list to check before you choose.' : 'A match for your formula and size preferences. Read the full ingredients before adding it to your routine.');
        set('price', variant.formatted); set('stock', note || (variant.available ? 'In stock at the moment. Your product page confirms availability.' : 'Currently sold out.'));
        result.querySelector('[data-kt-result-link]').href = product.url + '?variant=' + variant.id;
        const restock = result.querySelector('[data-kt-result-restock]');
        restock.hidden = variant.available;
        restock.href = '/pages/contact?topic=restock&product=' + encodeURIComponent(product.title + ' · ' + variant.title) + '#ContactForm';
        track('finder_completed');
        form.hidden = true; result.hidden = false; result.focus();
      });
      result.querySelector('[data-kt-result-link]').addEventListener('click', () => track('finder_product_clicked'));
      panel.querySelector('[data-kt-restart]').addEventListener('click', () => { form.reset(); step = 0; started = false; form.hidden = false; result.hidden = true; show(); questions[0].querySelector('input').focus(); });
      show();
    });
    root.querySelectorAll('[data-kt-duo]').forEach(form => {
      if (form.dataset.ready || !lip) return; form.dataset.ready = 'true';
      const jarSelect = form.querySelector('[data-kt-duo-jar]'), lipSelect = form.querySelector('[data-kt-duo-lip]'), button = form.querySelector('[data-kt-duo-submit]');
      const populate = () => {
        const size = form.querySelector('input:checked').value;
        jarSelect.replaceChildren(...jars.flatMap(p => p.variants.filter(v => v.available && sized(v, size)).map(v => new Option(p.title + ' · ' + v.title, v.id))));
        lipSelect.replaceChildren(...lip.variants.filter(v => v.available).map(v => new Option(v.title, v.id)));
        button.disabled = !jarSelect.options.length || !lipSelect.options.length;
        form.querySelector('[data-kt-duo-total]').textContent = 'CA$' + (size === '2' ? '45' : '60') + ' for the pair · billed in CAD';
      };
      form.querySelectorAll('input').forEach(input => input.addEventListener('change', populate)); populate();
      form.addEventListener('submit', async event => {
        event.preventDefault(); button.disabled = true;
        const error = form.querySelector('[data-kt-duo-error]'); error.textContent = '';
        try {
          const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js', {method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify({items:[{id:Number(jarSelect.value),quantity:1},{id:Number(lipSelect.value),quantity:1}]})});
          const body = await response.json(); if (!response.ok) throw new Error(body.description || 'This pairing is unavailable. Please choose again.');
          track('duo_added');
          location.href = (window.Shopify?.routes?.root || '/') + 'cart';
        } catch (e) { error.textContent = e.message || 'We couldn’t add the pair. Please try again.'; button.disabled = false; }
      });
    });
    const topic = document.getElementById('ContactForm-topic'), selected = new URLSearchParams(location.search).get('topic');
    if (topic && [...topic.options].some(o => o.value === selected)) topic.value = selected;
    const restockProduct = document.getElementById('ContactRestock');
    if (restockProduct && !restockProduct.value) restockProduct.value = (new URLSearchParams(location.search).get('product') || '').slice(0,160);
    if (topic && !topic.dataset.ready) {
      topic.dataset.ready = 'true';
      const updateTopic = () => {
        document.querySelectorAll('[data-kt-topic]').forEach(group => {
          const active = group.dataset.ktTopic === topic.value; group.hidden = !active;
          group.querySelectorAll('input').forEach(input => { input.disabled = !active; input.required = active && input.hasAttribute('data-kt-required'); });
        });
        const message = document.getElementById('ContactForm-body');
        if (message) message.placeholder = ({restock:'Which balm are you waiting for? Send us a note and we’ll reply with what we know about the next batch.',order:'What happened with your order, and how can we help?',pickup:'Which balms would you like, and when would you like to collect?',gift:'Tell us about the occasion and the balms you have in mind.',wholesale:'Tell us about your business, product interests and approximate quantities.',shipping:'Which products and quantities would you like delivered?',product:'What would you like to know about the balms?'})[topic.value];
      };
      topic.addEventListener('change', updateTopic); updateTopic();
    }

  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
